module.exports = __webpack_public_path__ + "img/no-image.28a81226.png";